import * as React from 'react';
import { Pager, PagerProps } from '@progress/kendo-react-data-tools';

export const CategoriesPager = (props: PagerProps) => {
  return <Pager {...props} previousNext={true} buttonCount={10} className="v2-categories-custom-pager"/>;
};
